import{a as m}from"./chunk-UDYR76RT.js";import{e as o,s as r}from"./chunk-GIDQTNXG.js";import{m as a}from"./chunk-HBP5N4FR.js";a();r();var g=t=>({egldValueData:{value:t,formattedValue:m({input:t}),decimals:o}});export{g as a};
//# sourceMappingURL=chunk-RCAWOLNR.js.map
